/* Copyright 2013 - 2024 Waiterio LLC */

export default function clearCookies() {
  document.cookie.split(';').forEach(cookie_ => {
    document.cookie = cookie_
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
  })
}
